import { datadogRum } from '@datadog/browser-rum';

export const addErrorDatadog = (error: Error) => {
  datadogRum.addError(error);
};
